import { httpRequest } from "@services/http";

/*
    Which template each of these ads was rebranded from (MPN-1508).

    Its own request rather than a field on the ad payload. That payload is also what a client
    reviewer is served, and an ad is renamed precisely so the client reads the rebrand's name
    instead of the template's.

    The server answers per viewer: an ad whose template you cannot see is simply absent from
    the response, so a client browsing a rebrand shared into their own catalog gets nothing
    back. One request covers a whole grid.
*/
export class CommandGetAdProvenance {
  async run(adIds: number[]): Promise<Record<number, string>> {
    if (adIds.length === 0) return {};
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/provenance/?ids=${adIds.join(",")}`;
    return await httpRequest<Record<number, string>>(url);
  }
}
